<template>
  <v-card>
    <div class="btn">
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        color="red"
        :top="y === 'top'"
      >
        {{ errorMsg }}
        <v-btn color="black" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-dialog v-model="dialog" width="600">
      <v-card>
        <v-card-title class="title blue accent-3">Assign task to agent</v-card-title>
        <v-card-text>
          <div v-if="availableAgentList">
            <v-layout row class="mt-1">
              <v-flex xs12>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-layout class="mx-0 px-0 mb-4">
                    <v-flex xs12 sm2 style="border-bottom: 1px dotted gray;" class="mr-4">ID</v-flex>
                    <v-flex xs12 sm3 style="border-bottom: 1px dotted gray;" class="mr-4">Name</v-flex>
                    <v-flex xs12 sm3 style="border-bottom: 1px dotted gray;" class="mr-4">Group ID</v-flex>
                    <v-flex xs12 sm4 style="border-bottom: 1px dotted gray;" class="">Number of Allowed Task</v-flex>
                  </v-layout>
                  
                    <v-layout class="mx-0 px-0"
                      
                      v-for="(element, index) in availableAgentList"
                      :key="index"
                    >
                      <v-flex xs12 sm2 class="mr-4">
                        <!-- <v-text-field class="my-0 py-0"
                          v-model="editedItem.assignAgentMemberInfo[index].dasher_id"
                          disabled
                          height="14"
                        ></v-text-field> -->
                        <p style="border-bottom: 1px dotted gray;">{{ index+1 }}</p>
                      </v-flex>
                      <v-flex xs12 sm3 class="mr-4">
                        <!-- <v-text-field class="my-0 py-0"
                          v-model="editedItem.assignAgentMemberInfo[index].name"
                          disabled
                          height="14"
                        ></v-text-field> -->
                        <p style="border-bottom: 1px dotted gray;">{{ element.dasher.first_name }} {{ element.dasher.last_name }}</p>
                      </v-flex>
                      <v-flex xs12 sm3 class="mr-4">
                        <!-- <v-text-field class="my-0 py-0"
                          v-model="
                            editedItem.assignAgentMemberInfo[index].agent_group_id
                          "
                          disabled
                          height="14"
                        ></v-text-field> -->
                        <p style="border-bottom: 1px dotted gray;">{{ element.agent_group_id }}</p>
                      </v-flex>
                      <v-flex xs12 sm4 class="">
                        <v-text-field class="my-0 py-0"
                          numeric
                          v-model="
                            availableAgentList[index].number_of_allowed_task
                          "
                          :rules="allowedTaskRules"
                          @keypress="isDigit($event)"
                          height="20"
                        ></v-text-field>
                        
                      </v-flex>
                    </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="success" flat @click="close">close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" flat @click="save">
            save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-title class="">
      <v-layout>
        <v-flex>
          <span class="headline black--text"
            >Assigned Agent Group to Project</span
          >
        </v-flex>
        <v-flex xs3 class="text-right">
          <v-btn @click="defineTask" v-if="availableAgentList.length>0" class="white--text" round color="red"
            >Assign task to agent</v-btn
          >
        </v-flex>
      </v-layout>
    </v-card-title>
    <v-card-text>
      <div>
        <div v-for="(agent_group, index1) in agent_groups" v-bind:key="index1">
          <v-card-text>
            <v-layout row class="font-weight-bold">
              <v-flex xs4>Group Name</v-flex>
              <v-flex xs4>Group Code</v-flex>
              <v-flex xs4>Number of agent</v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>{{ agent_group.name }}</v-flex>
              <v-flex xs4>{{ agent_group.code }}</v-flex>
              <v-flex xs4>{{ agent_group.numberOfAgent }}</v-flex>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title class="mt-3">
            <v-layout>
              <div>
                <span class="headline black--text">Assigned agent list</span>
              </div>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <div>
              <v-layout row class="mt-1">
                <v-flex xs12>
                  <v-layout class="mx-0 px-0 mb-4">
                    <v-flex
                      xs12
                      sm2
                      style="border-bottom: 1px dotted gray"
                      class="mr-4"
                      >SL</v-flex
                    >
                    <v-flex
                      xs12
                      sm3
                      style="border-bottom: 1px dotted gray"
                      class="mr-4"
                      >Name</v-flex
                    >
                    <v-flex
                      xs12
                      sm3
                      style="border-bottom: 1px dotted gray"
                      class="mr-4"
                      >Group ID</v-flex
                    >
                    <v-flex
                      xs12
                      sm4
                      style="border-bottom: 1px dotted gray"
                      class=""
                      >Number of Allowed Task</v-flex
                    >
                  </v-layout>

                  <v-layout
                    class="mx-0 px-0"
                    v-for="(element, index) in definedAgents"
                    :key="index"
                  >
                    <v-flex xs12 sm2 class="mr-4">
                      <p style="border-bottom: 1px dotted gray">
                        {{ index + 1 }}
                      </p>
                    </v-flex>
                    <v-flex xs12 sm3 class="mr-4">
                      <p style="border-bottom: 1px dotted gray">
                        {{ element.agent_info.first_name }}
                        {{ element.agent_info.last_name }}
                      </p>
                    </v-flex>
                    <v-flex xs12 sm3 class="mr-4">
                      <p style="border-bottom: 1px dotted gray">
                        {{ element.agent_group_id }}
                      </p>
                    </v-flex>
                    <v-flex xs12 sm4 class="">
                      <p style="border-bottom: 1px dotted gray">
                        {{ element.number_of_allowed_task }}
                      </p>
                    </v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                </v-flex>
              </v-layout>
            </div>
          </v-card-text>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
import { ROOT_URL } from "@/api/connectingUrls";
// import router from "../../router";

export default {
  props: {
    project_id: Number,
  },
  data: () => ({
    apiUrl: "project.agent-info-data",
    agent_groups: [],
    definedAgents: [],
    agent_group_data:{},
    availableAgentList:[],
    dialog:false,
    valid:true,
    snackbar:false,
    errorMsg:'',
    allowedTaskRules: [(v) => !!v || "This field is required"],
  }),

  computed: {
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },

  watch: {},

  created() {
    this.getComponent();
  },
  methods: {
    
    getComponent() {
      try {
        const token = window.localStorage.getItem("datadash_token");
        if (token != null) {
          return axios
            .get(`${ROOT_URL}/${this.apiUrl}/${this.$route.params.id}`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // if (response.data.statusCode == 200) {
                // console.log(response);
                
                this.agent_groups = response.data.data.agent_groups;
                this.definedAgents = response.data.data.definedAgents;
                this.agent_group_data.agent_group_id=this.agent_groups[0].id;
                this.agent_group_data.project_id=parseInt(this.$route.params.id);
                this.agent_group_data.agent_task_assign_method_id=this.agent_groups[0].agent_task_assign_method_id;
                this.agent_group_data.max_task_limit=this.agent_groups[0].max_task_limit;
                this.availableAgentList=response.data.data.availableAgents;
              // }
            });
        }
      } catch (error) {
        // console.log(error);
      }
    },

    defineTask() {
      // console.log(this.agent_group_data);
      if (this.agent_group_data.agent_task_assign_method_id != 3) {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
              axios
                .post(
                  `${ ROOT_URL }/${"define.project-task"}`,this.agent_group_data,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((response) => {
                  // console.log(response);
                  // if (response.data.data.success == 1) {
                  //   //
                  // }
                  this.errorMsg="Data has been saved";
                  this.snackbar=true;
                  this.close();
                });
            }
        } catch (error) {
          // console.log(error);
        }
      } else {
        this.dialog=true;
        // console.log(this.agent_group_data.agent_task_assign_method_id);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    getAgentGroupName(agent_group) {
      // console.log(agent_group);
      var agentText = "";
      agentText =
        "Group Name: " +
        agent_group.name +
        ", " +
        "\n Group Code: " +
        agent_group.code +
        ", " +
        " \n Number Of agent: " +
        agent_group.numberOfAgent;
      return agentText;
    },

    isDigit(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[0-9]+$/.test(char)) return false;
      // Match with regex
      else {
        this.digitValidate = true;
        e.preventDefault();
      } // If not match, don't add to input text
    },
    save() {
      if (this.$refs.form.validate()) {
        try {
          const token = window.localStorage.getItem("datadash_token");
          if (token != null) {
              axios
                .post(
                  `${ ROOT_URL }/${"define-task-to-agent"}`,this.availableAgentList,
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((response) => {

                  this.snackbar = true;
                  this.close();
                });
            }
        } catch (error) {
          // console.log(error);
        }
        
      }
    },
  },
};
</script>
<style scoped>
.headline {
  color: white;
}
.project {
  background: #ff2e2e;
}
</style>
